import './styles.scss'

interface HamburgerProps {
  isOpen?: boolean
  color?: string
  type?: '1' | '2'
}

export default function Hamburger({
  isOpen = false,
  type = '1',
  color = 'black',
}: HamburgerProps) {
  const className = isOpen ? 'hamburguer open' : 'hambuguer'

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 2.761H22V4.792H0V2.761Z"
        fill={color}
        className="hamburguer__line first"
      />
      {type === '1' ? (
        <path
          d="M0 9.98399H16.438V12.016H0V9.98399Z"
          fill={color}
          className="hamburguer__line center"
        />
      ) : (
        <path
          d="M0 10H22V12H0V10Z"
          fill={color}
          className="hamburguer__line center"
        />
      )}

      <path
        d="M0 17.208H22V19.239H0V17.208Z"
        fill={color}
        className="hamburguer__line last"
      />
    </svg>
  )
}
